import { ofType } from "redux-observable";
import { switchMap, takeUntil, map, take } from "rxjs/operators";
import { timer } from "rxjs";
import { FREQUENCY_TO_POLL_GET_MILLI_SECS, MAX_ALLOWED_POLLS_BEFORE_TIMEOUT } from "../../../constants";
import { NotificationTypeEnum, POLLING_NOTIFICATION_CLOSE_TIMEOUT } from "../../../actions/ui/types";
import { addNotification } from "../../../actions/ui";
import { START_GET_REPORT_DETAILS_POLLING_REQUEST, STOP_GET_REPORT_DETAILS_POLLING_REQUEST } from "../../../actions/types";
import { getReportDetailsAction } from "../../../actions";
export var getReportDetailsPollingEpic = function(action$) {
    var stopPolling$ = action$.pipe(ofType(STOP_GET_REPORT_DETAILS_POLLING_REQUEST));
    return action$.pipe(ofType(START_GET_REPORT_DETAILS_POLLING_REQUEST), switchMap(function(param) {
        var payload = param.payload;
        return timer(0, FREQUENCY_TO_POLL_GET_MILLI_SECS).pipe(take(MAX_ALLOWED_POLLS_BEFORE_TIMEOUT + 1), takeUntil(stopPolling$), map(function(pollCount) {
            if (pollCount === MAX_ALLOWED_POLLS_BEFORE_TIMEOUT) {
                return addNotification({
                    type: NotificationTypeEnum.ERROR,
                    body: "get_report_details_polling_notifications.polling_timed_out",
                    timeout: POLLING_NOTIFICATION_CLOSE_TIMEOUT
                });
            }
            return getReportDetailsAction.request(payload);
        }));
    }));
};
export default getReportDetailsPollingEpic;

//# sourceMappingURL=index.js.map